import { useCondition } from "@poolzfinance/strapi"

export default function Condition() {
  const { data } = useCondition()

  if (!data?.condition) return null

  return (
    <div className="mt-[78px] overflow-x-auto hide-scrollbar overflow-visible max-w-[1180px] mx-auto">
      <div className="my-8 px-4">
        <div
          className="text-[16px] leading-6 text-gray-700 my-8 px-4"
          dangerouslySetInnerHTML={{ __html: data.condition.Value.replace(/\n/g, "<br />") }}
        />
      </div>
    </div>
  )
}
